<template>
    <div>
        <el-form :inline="true" :model="searchForm">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid"  @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
              <el-form-item label="绑定次数：">
                <el-input v-model.trim="searchForm.bindCount"  @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input v-model.trim="searchForm.userPhone" @keyup.enter.native="getBindPhoneListHandler" clearable></el-input>
            </el-form-item>
            <el-form-item label="供应商：">
                <el-select v-model="searchForm.supplierCode" placeholder="请选择" clearable filterable>
                    <el-option v-for="item in branchSupplierOption" :value="item.id" :key="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item> 
            <el-form-item class="btnArea">
                <el-button type="primary" plain icon="el-icon-search" @click="getBindPhoneListHandler">查询</el-button>
                <el-button type="success" plain icon="el-icon-download" @click="confirmExportDialogVisible = true">导 出</el-button>
                <el-button type="success" @click="changeStateVisible1 = true">添加绑定</el-button> 

                 <el-button type="danger" @click="whiteClicks" icon="el-icon-delete">手机号黑名单</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border
		 fit
		 highlight-current-row
		 style="width: 100%;"
		 :header-cell-style="{background:'#f5f5f5'}"  >
            <el-table-column label="ICCID号" width="160" align="center" show-overflow-tooltip>
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
             <el-table-column prop="vriNo" label="虚拟号" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="userPhone" label="手机号"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="绑定时间"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idcard" label="身份证号"  align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idcardRemark" label="实名详情"  align="center" show-overflow-tooltip></el-table-column>
              <el-table-column prop="stateName" label="默认状态"  align="center" show-overflow-tooltip></el-table-column>
             <el-table-column label="操作" width="180">
                <template slot-scope="scope">

                     <el-button
                    size="mini"
                    type="primary"
                    @click="updateDefault(scope.row.iccid)">设为默认</el-button>


                    <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.row.id)">删除</el-button>

                </template>
            </el-table-column>
        </el-table>   
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        <el-dialog :append-to-body="true" 
            title="提示"
            :visible.sync="confirmExportDialogVisible"
            width="30%">
            <span>确定要导出吗</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="confirmExportDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="exportHandle">确 定</el-button>
            </span>
        </el-dialog>


         <el-dialog :append-to-body="true"  title="添加绑定" :visible.sync="changeStateVisible1" width="600px" @close="changeStateCancel" :close-on-click-modal="false">
            <el-form ref="changeStateForm" :model="changeStateForm"  label-width="100px">
                <el-form-item label="卡号：" prop="iccid">
                    <el-input v-model="changeStateForm.iccid" placeholder="ICCID或者虚拟号"></el-input>
                </el-form-item>
                <el-form-item label="手机号：" prop="userPhone">
                    <el-input v-model="changeStateForm.userPhone"  placeholder="用户手机号"></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="changeStateForm.name" placeholder="(选填)"></el-input>
                </el-form-item>
                <el-form-item label="身份证号：" prop="idcard">
                    <el-input v-model="changeStateForm.idcard"  placeholder="(选填) "></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeStateCancel">取 消</el-button>
                <el-button type="primary" @click="sureChangeStateHandler1">确 定</el-button>
            </div> 
        </el-dialog>






    <!--白名单弹窗-->
        <el-dialog :append-to-body="true" title="黑名单" :visible.sync="whiteShows" width="600px" :close-on-click-modal="false">
            <el-input v-model="querd.iccid" placeholder="请输入iccid" clearable style="width:200px;margin-right:10px;"></el-input>
            <el-button type="default" @click="searcts">查询</el-button>
            <el-button type="primary" @click="addCards">添加手机号</el-button>
            <el-button type="danger" @click="delCards">删除手机号</el-button>
            <el-table :data="dialog.tableData"
                border
                fit
                highlight-current-row
                style="width: 100%;margin:10px 0;"
                :header-cell-style="{background:'#f5f5f5'}"
                height="400"
                >
                    <el-table-column prop="id" label="id" align="center"></el-table-column>
                    <el-table-column prop="userPhone" label="手机号" align="center"></el-table-column>
                    <el-table-column label="操作" align="center" fixed="right">
                        <template slot-scope="scope">
                            <el-link :underline="false" type="primary" @click="delDialogDatas(scope.row)">删除</el-link>
                        </template>
                    </el-table-column>
                </el-table> 
                <el-pagination
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="dialog.currentPage1"
                    :page-sizes="[15, 50, 100, 500]"
                    :page-size="dialog.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="dialog.total">
                </el-pagination>
        </el-dialog>
        <!---新增白名单-->
        <el-dialog :append-to-body="true" :title="title1" :visible.sync="addWhiteShows" width="600px" :close-on-click-modal="false">
            <el-input v-model="iccidStrs" placeholder="请输入请输入1个或多个手机号,多个请用逗号、空格、或者换行分隔" :rows="10" type="textarea" clearable style="margin-right:10px;" />
            <div style="margin-top:10px">
                <el-button type="default" @click="addSumbits" v-if="title1==='新增白名单'">确定添加</el-button>
                <el-button type="default" @click="addDeletes" v-if="title1==='删除白名单'">确定删除</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import {getBindPhoneList, exportRecord} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
             dialog:{
                    tableData: [],
                    currentPage: 1,
                    pageSize: 15,
                    total: 0
            },
             title:'',
                title1:'',
                programmeDialog:false,
                whiteShow:false,
                whiteShows:false,
                querd:{
                    iccid:''
                },
                iccidStrs:'',
                addWhiteShow:false,
                addWhiteShows:false,


              changeStateForm: {
                iccid: '',
                userPhone: '',
                 name: '',
                idcard: ''
            },
            changeStateVisible1:false,
            searchForm: {
                iccid: '',
                userPhone: '',
                supplierCode:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
            branchSupplierOption:[],
            confirmExportDialogVisible: false,
        }
    },
    methods: {

         searcts(){
                this.getDialogDatas()
            },
             getDialogDatas($event){
                common.resetCurrentPage(this, $event, 'dialog');
                var data = common.getRequestParams(this, 'dialog',this.querd);
                common.sysRequest('bindPhone/sim/out/listPage', data, 'post').then(res => {
                    common.listCallback(this, res, 'dialog');
                })
            },
              handleSizeChange1(val){
                this.dialog.pageSize = val;
                this.getDialogDatas();
            },

            handleCurrentChange1(val){
                this.dialog.currentPage = val;
                this.getDialogDatas();
            },
          //白名单
            whiteClicks(){
                this.whiteShows=true
                this.getDialogDatas()
            },
             addCards(){
                this.iccidStrs = ''
                this.title1="新增白名单"
                this.addWhiteShows = true
            },
            delCards(){
                this.iccidStrs = ''
                this.title1="删除白名单"
                this.addWhiteShows = true
            },
               //批量新增
            addSumbits(){
                this.$confirm("确定要新增数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    common.sysRequest('bindPhone/sim/out/add/batch', {iccidStrs:this.iccidStrs}, 'post').then(res => {
                        if(res.data.code == 200){
                            this.addWhiteShows = false
                            this.getDialogDatas()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //批量删除
            addDeletes(){
                this.$confirm("确定要删除数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    common.sysRequest('bindPhone/sim/out/delete/batch', {iccidStrs:this.iccidStrs}, 'post').then(res => {
                        if(res.data.code == 200){
                            this.addWhiteShows = false
                            this.getDialogDatas()
                            this.$message.success('操作成功');
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },
            //单个删除
            delDialogDatas(data){
                this.$confirm("确定要删除该数据吗？", "提示" ,{          
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    common.sysRequest('bindPhone/sim/out/delete',{id:data.id}, 'post').then(res => {
                        if(res.data.code == 200){
                            this.$message.success('操作成功');
                            this.getDialogDatas()
                        }else{
                            this.$message.error(res.data.message);
                        }
                    })
                }).catch(()=>{});
            },




        updateDefault(iccid){
            var data={
                iccid:iccid,
                defaultIccid:iccid
            }
            common.sysRequest('bindPhone/update/default',data, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                    this.getBindPhoneListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },
          changeStateCancel(){
             this.changeStateVisible1 = false;
            this.$refs.changeStateForm.resetFields();
        },
        handleDelete(id){
            var data={
                id:id
            }
             this.$confirm('确定要进行删除解绑操作?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                common.sysRequest('bindPhone/delete/bind', data, 'post').then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getBindPhoneListHandler();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })

            }).catch(() => {});
        },

         sureChangeStateHandler1(){
             common.sysRequest('bindPhone/insert/bind', this.changeStateForm, 'post').then(res => {
                if(res.data.code == 200){
                     this.$message.success(res.data.message);
                    this.changeStateVisible1 = false;
                    this.getBindPhoneListHandler();
                }else{
                    this.$message.error(res.data.message);
                }
            })
        },     
        getBindPhoneListHandler($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getBindPhoneList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        exportHandle(){
            exportRecord(this.searchForm).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);
                }else{
                    this.$message.error(res.data.message)
                }
                this.confirmExportDialogVisible = false;
            })
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getBindPhoneListHandler();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getBindPhoneListHandler();
        }
    },
    created(){ 
             common.getBranchSupplierOptionCom(this, 'branchSupplierOption');
        this.getBindPhoneListHandler();
    }
}
</script>

<style lang="less" scoped>

</style>

